__turbopack_context__.v({
  "bottomGradient": "StickySideAd-module-scss-module__mtfWwq__bottomGradient",
  "reserved": "StickySideAd-module-scss-module__mtfWwq__reserved",
  "wideScreenAdAnchor": "StickySideAd-module-scss-module__mtfWwq__wideScreenAdAnchor",
  "widescreenAd": "StickySideAd-module-scss-module__mtfWwq__widescreenAd",
});
